const getSortedObject = srcObj => {
	const sortedObject = Object.keys(srcObj)
		.sort()
		.reduce((obj, key) => ((obj[key] = srcObj[key]), obj), {});
	return sortedObject;
};

export default getSortedObject;
